export enum ExecutionContext {
  OBJECT = 'OBJECT',
  CLASS = 'CLASS',
  DRAFT = 'DRAFT',
}
